import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { api, LOGO_URL } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("pblux_admin_token")) {
      navigate("/admin/dashboard");
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const r = await api.post("/admin/login", { username, password });
      localStorage.setItem("pblux_admin_token", r.data.token);
      localStorage.setItem("pblux_admin_user", r.data.username);
      toast.success("Welcome back, admin!");
      navigate("/admin/dashboard");
    } catch (e) {
      toast.error("Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen hero-bg noise flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="absolute top-6 left-6">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-gold-300 hover:text-gold-100">
          <ArrowLeft className="w-4 h-4" /> Back to Site
        </Link>
      </div>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="PB-Lux" className="w-20 h-20 mx-auto rounded-full border border-gold-500/40" />
          <h1 className="font-display text-4xl mt-5 text-gold-gradient">Admin Portal</h1>
          <p className="text-sm text-foreground/55 mt-2">Sign in to manage PB-Lux</p>
        </div>
        <form onSubmit={submit} className="glass-card rounded-2xl p-7 space-y-5" data-testid="admin-login-form">
          <div>
            <Label className="text-xs uppercase tracking-wider">Username</Label>
            <Input data-testid="admin-username" value={username} onChange={(e) => setUsername(e.target.value)} className="mt-2 bg-ink-800/60 border-gold-500/20" autoFocus />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Password</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 bg-ink-800/60 border-gold-500/20" />
          </div>
          <button type="submit" disabled={loading} className="btn-gold w-full disabled:opacity-60" data-testid="admin-login-submit">
            <Lock className="w-4 h-4" /> {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
